import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"
import Auth from "@/constants/Auth"

const AuthLayout = () => {
  return <Outlet />
}

export const Route = createFileRoute("/_auth")({
  beforeLoad: ({ context }) => {
    if (!context.auth?.isAuthenticated) {
      throw redirect({
        to: Auth.unauthorizedRedirectionPath,
      })
    }
  },
  component: AuthLayout,
})

